import React, { useCallback } from 'react';
import { Box, FormHelperText, TextField, Typography, useTheme } from '@material-ui/core';
import { useTranslate } from 'react-admin';
import { usePayment } from '../../hooks';
import MultipleFilesUploader from '../../../../base/components/common/MultiplierFilesUploader';

const PaymentPayslip = () => {
  const t = useTranslate();
  const theme = useTheme();

  const { setPayslip, payslip } = usePayment();

  const handleDescriptionChange = useCallback((e) => {
    const desc = e.target.value;
    setPayslip((payslip) => ({
      ...payslip,
      description: desc,
    }));
  }, []);

  const handleProofChange = useCallback((proofs) => {
    setPayslip((payslip) => ({
      ...payslip,
      paymentProofKeys: proofs,
    }));
  }, []);

  return (
    <Box
      display="flex"
      flexDirection="column"
      sx={{
        gap: 8,
      }}
    >
      <Box>
        <TextField
          label={t('resources.payment.fields.description')}
          multiline
          required
          variant="outlined"
          rows={3}
          value={payslip?.description || ''}
          onChange={handleDescriptionChange}
          error={payslip?.errors?.description}
        />
        <FormHelperText error>{payslip?.errors?.description || <span>&#8203;</span>}</FormHelperText>
      </Box>
      <Box>
        <Box
          component={Typography}
          gutterBottom
          color={payslip?.errors?.paymentProofKeys ? theme.palette.error.main : theme.palette.grey[800]}
        >
          {`${t('resources.payment.fields.proofs')} *`}
        </Box>
        <MultipleFilesUploader
          value={payslip?.paymentProofKeys || []}
          onChange={handleProofChange}
          error={!!payslip?.errors?.paymentProofKeys}
        />
        <FormHelperText error>{payslip?.errors?.paymentProofKeys || <span>&#8203;</span>}</FormHelperText>
      </Box>
    </Box>
  );
};

export default PaymentPayslip;

export const validatePayslip = (values, t) => {
  const errors = {};
  const desc = values?.description?.trim?.();
  if (!desc?.length) {
    errors.description = t('ra.validation.required');
  } else if (desc.length > 255) {
    errors.description = t('ra.validation.maxLength', {
      max: 255,
    });
  }

  if (!values?.paymentProofKeys?.length) {
    errors.paymentProofKeys = t('ra.validation.required');
  }

  return Object.keys(errors)?.length ? errors : undefined;
};
